import React, { useState, useEffect, useCallback } from "react";
import axiosInstance from "../../../api/axiosInstance";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import Grid3x3OutlinedIcon from '@mui/icons-material/Grid3x3Outlined';
import ShortTextRoundedIcon from '@mui/icons-material/ShortTextRounded';
import NotesRoundedIcon from '@mui/icons-material/NotesRounded';
import NumbersRoundedIcon from '@mui/icons-material/NumbersRounded';
import CategoryRoundedIcon from '@mui/icons-material/CategoryRounded';
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import MapRoundedIcon from '@mui/icons-material/MapRounded';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import useEntity from "../../../api/useEntity";
import EditModal from "../../../components/editModal/editModal";
import "./fuhrpark.scss"

const Fuhrpark = () => {
    const [items, setItems] = useState([]);
    const [categories, setCategories] = useState([]);
    const [driver, setDriver] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null);

    const fetchData = useCallback(async () => {
        try {
            const [itemsRes, categoriesRes, driverRes] = await Promise.all([
                axiosInstance.get('data/items'),
                axiosInstance.get('forms/categories?layer=1'),
                axiosInstance.get('forms/driver')
            ]);
            setItems(itemsRes.data);
            setCategories(categoriesRes.data);
            setDriver(driverRes.data);
        } catch (err) {
            console.error(err);
        }
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const { item, setItem, isLoading, save } = useEntity({
        endpoint: "data/items",
        selectedItem,
        onSuccess: () => {
            fetchData();
            setSelectedItem(null);
        }
    });

    return (
        <div className="fuhrpark">
            <button className="add" onClick={() => setSelectedItem(true)}>Fahzeug hinzufügen</button>
            <div className="tableWrapper">
                <table>
                    <thead>
                        <tr>
                            <th>Auto</th>
                            <th>Beschreibung</th>
                            <th>Kennzeichen</th>
                            <th>Fahrer</th>
                            <th>Kategorie</th>
                            <th>Nur Karte</th>
                            <th className="options"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map((i) => (
                            <tr key={i.id}>
                                <td>{i.alias}</td>
                                <td>{i.description}</td>
                                <td>{i.kennzeichen}</td>
                                <td>{i.driverAlias}</td>
                                <td>{i.categoryName}</td>
                                <td>
                                    {i.onlyMap === 1 && (
                                        <CheckCircleOutlineRoundedIcon />
                                    )}
                                </td>
                                <td className="options">
                                    <div className="controls">
                                        <EditOutlinedIcon onClick={() => setSelectedItem(i.id)} />
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {selectedItem && (
                <EditModal
                    title="Fuhrpark"
                    isLoading={isLoading}
                    onClose={() => setSelectedItem(null)}
                    onSave={save}
                >
                    <div className="group">
                        <Grid3x3OutlinedIcon />
                        <input
                            type="text"
                            value={item.id || ""}
                            placeholder="ID"
                            disabled={selectedItem !== true}
                            onChange={(e) =>
                                setItem(prev => ({
                                    ...prev,
                                    id: e.target.value
                                }))
                            }
                        />
                    </div>
                    <div className="group">
                        <ShortTextRoundedIcon />
                        <input
                            type="text"
                            value={item.alias || ""}
                            placeholder="Auto"
                            required
                            onChange={(e) =>
                                setItem(prev => ({
                                    ...prev,
                                    alias: e.target.value
                                }))
                            }
                        />
                    </div>
                    <div className="group">
                        <NotesRoundedIcon />
                        <input
                            type="text"
                            value={item.description || ""}
                            placeholder="Beschreibung"
                            required
                            onChange={(e) =>
                                setItem(prev => ({
                                    ...prev,
                                    description: e.target.value
                                }))
                            }
                        />
                    </div>
                    <div className="group">
                        <NumbersRoundedIcon />
                        <input
                            type="text"
                            value={item.kennzeichen || ""}
                            placeholder="Kennzeichen"
                            onChange={(e) =>
                                setItem(prev => ({
                                    ...prev,
                                    kennzeichen: e.target.value
                                }))
                            }
                        />
                    </div>
                    <div className="group">
                        <ManageAccountsIcon />
                        <select
                            type="text"
                            value={item.driver || ""}
                            onChange={(e) =>
                                setItem(prev => ({
                                    ...prev,
                                    driver: e.target.value
                                }))
                            }
                        >
                            <option value="">Kein Fahrer</option>
                            {driver.map((c) => (
                                <option value={c.value} key={c.value}>{c.label}</option>
                            ))}
                        </select>
                    </div>
                    <div className="group">
                        <CategoryRoundedIcon />
                        <select
                            type="text"
                            value={item.category}
                            required
                            onChange={(e) =>
                                setItem(prev => ({
                                    ...prev,
                                    category: e.target.value
                                }))
                            }
                        >
                            <option value="">Kategorie wählen</option>
                            {categories.map((c) => (
                                <option value={c.id} key={c.id}>{c.name}</option>
                            ))}
                        </select>
                    </div>
                    <div className="group" onClick={() =>
                        setItem(prev => ({
                            ...prev,
                            onlyMap: !prev.onlyMap
                        }))
                    }>
                        <MapRoundedIcon />
                        <div className="checkbox">
                            <div className="box">
                                <div className={item.onlyMap ? "check on" : "check"} />
                            </div>
                            <span>Nur Karte</span>
                        </div>
                    </div>
                    <div className="bottom">
                        <div className="left">
                            <button type="submit">Speichern</button>
                        </div>
                    </div>
                </EditModal>
            )}
        </div>
    )
};

export default Fuhrpark